import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=';
    clientId: string = 'ad2d0388-6511-4828-9ac6-8c0f8b0f6ade-INVI';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();